module.exports = __webpack_public_path__ + "static/media/bgvideo.33c4cddf.mp4";